import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, catchError, debounceTime, switchMap, first } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class UsernameValidatorService {
  constructor(private http: HttpClient) {}

  checkUsernameUnique() {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const value = (control.value || '').trim();

      if (!value || value.length < 4) {
        return of(null);
      }

      return of(value).pipe(
        debounceTime(400),
        switchMap(username =>
          this.http.get<{ exists: boolean }>(
            `/validate/account?identifier=${encodeURIComponent(username)}`
          )
        ),
        map(response => (response.exists ? { usernameTaken: true } : null)),
        catchError(() => of(null)),
        first()
      );
    };
  }
}
